var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.21448C6.3405 6.21448 1.875 12 1.875 12C1.875 12 6.3405 17.7862 12 17.7862C16.3275 17.7862 22.125 12 22.125 12C22.125 12 16.3275 6.21448 12 6.21448ZM12 15.6045C10.0125 15.6045 8.39475 13.9875 8.39475 12C8.39475 10.0125 10.0125 8.39473 12 8.39473C13.9875 8.39473 15.6052 10.0125 15.6052 12C15.6052 13.9875 13.9875 15.6045 12 15.6045ZM12 9.89548C11.7203 9.8902 11.4424 9.94072 11.1825 10.0441C10.9226 10.1475 10.6859 10.3016 10.4863 10.4975C10.2866 10.6934 10.128 10.9272 10.0198 11.1851C9.91153 11.443 9.85577 11.7199 9.85577 11.9996C9.85577 12.2793 9.91153 12.5562 10.0198 12.8141C10.128 13.072 10.2866 13.3058 10.4863 13.5017C10.6859 13.6976 10.9226 13.8517 11.1825 13.9551C11.4424 14.0585 11.7203 14.109 12 14.1037C12.5512 14.0933 13.0763 13.8671 13.4624 13.4736C13.8485 13.0801 14.0648 12.5509 14.0648 11.9996C14.0648 11.4483 13.8485 10.9191 13.4624 10.5256C13.0763 10.1321 12.5512 9.90588 12 9.89548Z",
    fill: "#49454F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.bef32ecebbeb62101f8e9ea64b417849.svg";
export { ForwardRef as ReactComponent };